import { lazyLoad } from 'utils/loadable';

export const DocumentsPage = lazyLoad(
  () => import('./index'),
  module => module.DocumentsPage,
);
